export default __webpack_public_path__ + "static/media/agen_referral_cara3.6ff33f97.svg";